import React from 'react';
import { Section } from './ui/Section';
export function Objections() {
  const objections = [{
    q: "I don't have time.",
    a: "That's the point. The whole system is built around 5–10 minute windows."
  }, {
    q: "I won't follow through.",
    a: "You don't need perfect follow-through. You need a loop that works even when you're fried."
  }, {
    q: 'My baby is unpredictable.',
    a: "Good. This isn't a routine. It's a reset."
  }];
  return <Section background="cream" data-id="element-110">
      <div className="max-w-3xl mx-auto" data-id="element-111">
        <h2 className="text-3xl font-serif text-[#4A4238] mb-10 text-center" data-id="element-112">
          Common Questions
        </h2>

        <div className="space-y-6" data-id="element-113">
          {objections.map((obj, index) => <div key={index} className="bg-white p-6 rounded-xl border border-[#E8E0D5] shadow-sm" data-id="element-114">
              <h3 className="text-lg font-bold text-[#4A4238] mb-2" data-id="element-115">
                "{obj.q}"
              </h3>
              <p className="text-[#8C7E6E]" data-id="element-116">{obj.a}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}